import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { lastchanceList, categoryList } from '../services/General-service';
import Loader from "./Loader";
import { Link } from 'react-router-dom';

function Shipped({ showlastchancetobuy, sectionTitle }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [lastchanceArr, setlastchanceArr] = useState([]);
  const [apiTitle, setApiTitle] = useState('');
  const [loading, setLoading] = useState(true);

  const CustomPrevArrow = ({ className, style, onClick, isDisabled }) => (
    <button
      className={className}
      style={{
        ...style,
        display: isDisabled ? "none" : "block",
      }}
      onClick={!isDisabled ? onClick : null}
    />
  );

  const CustomNextArrow = ({ className, style, onClick }) => (
    <button className={className} style={{ ...style }} onClick={onClick} />
  );

  const totalItems = Array.isArray(lastchanceArr) ? lastchanceArr.length : 0;
  const desktopSlidesToShow = Math.min(3, totalItems || 1);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: desktopSlidesToShow,
    slidesToScroll: Math.min(3, totalItems || 1),
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    prevArrow: <CustomPrevArrow isDisabled={currentSlide === 0} />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: desktopSlidesToShow,
          slidesToScroll: Math.min(3, totalItems || 1),
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: Math.min(2, totalItems || 1),
          slidesToScroll: Math.min(2, totalItems || 1),
          initialSlide: 0
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: Math.min(2, totalItems || 1),
          slidesToScroll: Math.min(2, totalItems || 1)
        }
      }
    ]
  };

  const mapItems = (list = []) =>
    (Array.isArray(list) ? list : [])
      .map((item) => ({
        id: item?.id,
        title: item?.title || item?.name || '',
        thumbnail: item?.thumbnail || item?.cover || item?.icon || '',
      }))
      .filter((item) => item.id && item.thumbnail);

  const getlastchanceList = () => {
    setLoading(true);
    lastchanceList()
      .then(async (data) => {
        let items = mapItems(data?.data);
        setApiTitle(data?.section_ttile || data?.section_title || '');

        if (items.length === 0) {
          try {
            const fallback = await categoryList('');
            items = mapItems(fallback?.data).slice(0, 8);
          } catch (fallbackError) {
            console.error("Error fetching fallback categories:", fallbackError);
          }
        }

        setlastchanceArr(items);
      })
      .catch(async (error) => {
        console.error("Error fetching data list:", error);
        try {
          const fallback = await categoryList('');
          setlastchanceArr(mapItems(fallback?.data).slice(0, 8));
        } catch (fallbackError) {
          console.error("Error fetching fallback categories:", fallbackError);
          setlastchanceArr([]);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!showlastchancetobuy) return;
    getlastchanceList();
  }, [showlastchancetobuy]);

  if (!showlastchancetobuy) return null;
  if (loading) return <Loader />;
  if (!totalItems) return null;

  return (
    <div className='App'>
      <div className="BreakPointContainer">
        <div className="CarouselSectionContainer last-chance-to-buy">
          <div className="layout row justify-space-between align-center text-left SectionTitle">
            <h1 className='m-t-0 m-b-0 demi-bold'>
              {apiTitle || sectionTitle || 'LAST CHANCE TO BUY'}
            </h1>
          </div>
          <div className="layout">
            <div className="flex left-align-slick xs12">
              <Slider {...settings}>
                {lastchanceArr.map((data, index) => (
                  <div className='item' key={data.id || index}>
                    <div className="CarouselSection category">
                      <div className="prel Gutter">
                        <Link to={`/category/?category_ids=${data.id}`}>
                          <div className="DynamicHeightLoaderWrapper last-chance-media" style={{ paddingTop: '112%' }}>
                            <div className="DynamicHeightLoader layout row align-center justify-center" style={{ paddingTop: '0' }}>
                              <img src={data.thumbnail} alt={data.title} className='img-resp DynamicHeightLoaderImage' style={{ padding: '0px' }} />
                            </div>
                            <div className="animated-bg-placeholder"></div>
                          </div>
                          <div className="ImageTextDetail CategoryImageTextDetail">
                            <label className="h3 demi-bold ellipsis ImageTextLabelBottom block font-normal"> {data.title} </label>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Shipped;
